module.exports = __webpack_public_path__ + "static/WelcomeToElk11-14103e914297217e812b5b02a03ed71a.png";